import { render, staticRenderFns } from "./OpenIconConfig.vue?vue&type=template&id=50a7ebde&scoped=true"
import script from "./OpenIconConfig.vue?vue&type=script&lang=ts"
export * from "./OpenIconConfig.vue?vue&type=script&lang=ts"
import style0 from "./OpenIconConfig.vue?vue&type=style&index=0&id=50a7ebde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7ebde",
  null
  
)

export default component.exports